export const homeSectionId = '7d8rB0otv5XDHGsbqHwrQc';
export const directorySectionId = '2IEt1UBA0wxu3xu4I8Fxz3';
export const eventsSectionId = '2EJtkhIdVjMEThLf8suD7n';
export const eventsSectionSlug = 'events';
export const newsSectionPath = '/news/articles/.2QRWg5m3u7eBq26dnLuvDA';
export const termsPath = '/about/pages/terms-of-use-&-privacy-policy';
export const privacyPolicyPath = '/.2IfpdFuHYI2yq6siu84Kik/pages/73Ixsz4YWArIEwrRF9u3m4';
export const trainingSection = '/training/resources/.2KYRLE2IUB5Rvbnpnwul1j';
export const downloadsSection = '/downloads/resources/.6TC1395w6VN1RZ18hdlos4';
